import { MwSelectorModel } from 'app/models/selector.model';

export class MwActiveFilterModel {
  constructor(full: MwSelectorModel[]) {
    this.full = full.sort((a, b) => a.text.localeCompare(b.text));
    this.filtered = this.full.filter((i) => i.isActive !== false);
  }

  full: MwSelectorModel[];
  filtered: MwSelectorModel[];

  includeIfExist(itemId: number): void {
    this.filtered = this.full.filter(
      (i) => i.isActive !== false || i.value === itemId
    );
  }

  includeIfExistMultiple(itemIds: number[]): void {
    this.filtered = this.full.filter(
      (i) =>
        i.isActive !== false ||
        (itemIds !== null && itemIds.indexOf(i.value) > -1)
    );
  }
}
